import { Action, Dispatch } from 'redux';
import { getAllTeams, IVaultTeam } from '../../api/vault/teams';
import { Sport } from '../../enums';
import { getLocalization } from '../localization';
import { IAppState } from '../reducers';
import { selectUserOrgsSecurityProfiles } from '../user/userOrgRole';

export interface IState {
  teams: IVaultTeam[];
  currentTeam: IVaultTeam;
  sport: string;
  timeout: boolean;
}

export enum ActionType {
  Init = 'InitExchange.Init',
}

export interface IInitExchangeAction extends Action<ActionType> {
  payload?: any;
}

const INITIAL_STATE: IState = {
  teams: [],
  currentTeam: null,
  sport: Sport.Football, // Default to football for now
  timeout: false,
};

export default function reducer(state: IState = INITIAL_STATE, action: IInitExchangeAction): IState {
  switch (action.type) {
    case ActionType.Init: {
      return {
        ...state,
        teams: action.payload.teams,
        currentTeam: action.payload.currentTeam,
        sport: action.payload.sport,
        timeout: action.payload.timeout,
      };
    }
    default:
      return state;
  }
}

export const init = () => async (
  dispatch: Dispatch,
  getState: () => IAppState,
) => {
  const state = getState();
  const securityProfiles = selectUserOrgsSecurityProfiles(state);
  const teamsRes = await getAllTeams();
  const teams = teamsRes.data?.data || [];
  const sourceTeam = teams.find(({ _id }) => securityProfiles?.find(({ team_id }) => _id === team_id));
  let sourceTimeout = false;
  if (securityProfiles && securityProfiles[0]) sourceTimeout = securityProfiles[0].exchange_timeout_enabled;
  const sport = sourceTeam ? sourceTeam.Sport : Sport.Football;

  dispatch({
    type: ActionType.Init,
    payload: {
      teams,
      currentTeam: sourceTeam,
      sport,
      timeout: sourceTimeout,
    },
  });

  await getLocalization(sport)(dispatch, getState);
};
